<template>
  <div class="lineupcard">
    <a
      :href="'#' + list.id"
      v-smooth-scroll="{ duration: 500, offset: -100, updateHistory: false }"
    >
      <div class="card-img">
        <img :src="'images/' + list.id + '/' + list.mainimg" />
      </div>
      <div class="card-tx">
        <img
          class="vr-icon"
          src="@/assets/images/common/ico_360.svg"
          v-if="list.vrimg"
        />
        <span class="status sale" v-if="list.status == 1">見学受付中</span>
        <span class="status sold" v-else-if="list.status == 0">売約済</span>
        <span class="status const" v-else-if="list.status == 2">建設中</span>
        <span class="status const" v-else-if="list.status == 3">
          オーダー新築
        </span>
        <h3>{{ list.name }}</h3>
        <h4 class="maincopy">{{ list.maincopy }}</h4>
        <div class="link-arrow">
          <a
            v-if="list.status == 1"
            :href="'#' + list.id"
            v-smooth-scroll="{
              duration: 500,
              offset: -60,
              updateHistory: false,
            }"
          >
            詳しくはこちら
          </a>
        </div>
      </div>
    </a>
  </div>
</template>
<script>
export default {
  setup() {},
  props: ["id", "locate"],
  computed: {
    list() {
      let list = this.$alllist[this.locate][this.id];
      return list;
    },
  },
};
</script>
<style lang="scss" scoped>
.lineupcard {
  border-radius: 1rem;
  overflow: hidden;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
  transition: 0.25s ease-in-out;
  &:hover {
    transform: translateY(-0.5rem);
    .card-img {
      img {
        transform: scale(1.05);
      }
    }
  }
  .card-img {
    width: 100%;
    height: auto;
    aspect-ratio: 3/2;
    img {
      height: 100%;
      width: 100%;
      object-fit: cover;
      transition: 0.25s ease-in-out;
    }
  }
  .card-tx {
    background-color: white;
    padding: 1em;
    position: relative;
    .vr-icon {
      position: absolute;
      right: 0;
      top: -1rem;
      margin: 0 0.5rem;
      width: clamp(36px, 22.5%, 60px);
    }
    .status {
      line-height: 1rem;
      display: inline-block;
      font-weight: bold;
      font-size: 0.8rem;
      color: white;
      padding: 0.5em 1em 0.25em 1em;
      margin-bottom: 1rem;
      &.sale {
        background-color: $color_red;
      }
      &.sold {
        background-color: $color-gray;
      }
      &.const {
        background-color: $color_blue;
      }
    }
    h3 {
      font-size: clamp(1rem, 1.5vw, 1.25rem);
      font-weight: bold;
      padding-bottom: 0.5rem;
    }
    .maincopy {
      font-size: 0.8rem;
      color: $fontcolor_sub;
    }
    .link-arrow {
      color: $color_blue;
      font-weight: bold;
      margin-top: 1rem;
      width: 100%;
      text-align: right;
      a {
        font-size: clamp(0.8rem, 1vw, 1rem);
        position: relative;
        line-height: 1.5;
        display: inline-flex;
        align-items: center;
        vertical-align: middle;
        &::after {
          content: "";
          width: 1.2em;
          height: 1.2em;
          display: block;
          background-image: url("@/assets/images/common/arrow_small.svg");
          background-repeat: no-repeat;
          background-position: right center;
          background-size: contain;
          margin-left: 0.25em;
          margin-bottom: 0.2em;
        }
      }
    }
  }
}
</style>
